module.exports = __webpack_public_path__ + "/images/mockup-aportacions-it.74259b6.png";